<div
  class="typo-h5-semibold flex max-h-[16px] items-center gap-1 rounded px-2 py-1"
  [ngClass]="{
    'border-[1px] border-solid border-text-extra-light': getStatusColorHex() === '#ffffff'
  }"
  [style.background-color]="getStatusColorHex()"
  [style.color]="getStatusTextColor()"
>
  <p class="typo-h8-bold">
    {{ getStatusAbbreviation() }}
  </p>
</div>
